module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.58aef543.ttf";